import { render, staticRenderFns } from "./MyCourse.vue?vue&type=template&id=03cc705e&scoped=true"
import script from "./MyCourse.vue?vue&type=script&lang=ts"
export * from "./MyCourse.vue?vue&type=script&lang=ts"
import style0 from "./MyCourse.vue?vue&type=style&index=0&id=03cc705e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cc705e",
  null
  
)

export default component.exports